import { useState, FormEvent } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = (e: FormEvent) => {
    e.preventDefault();
    setEmail('');
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-12 gap-12 mb-12">
          <div className="md:col-span-5">
            <h3 className="text-2xl font-light mb-4">Stay Updated</h3>
            <p className="text-gray-400 text-sm mb-6">
              Subscribe to our newsletter for HVAC tips, seasonal maintenance reminders, and exclusive offers.
            </p>
            <form onSubmit={handleNewsletterSubmit} className="flex gap-3">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                required
                className="flex-1 px-0 py-3 bg-transparent border-0 border-b border-gray-600 focus:border-white outline-none transition-colors text-sm text-white placeholder-gray-500"
              />
              <button
                type="submit"
                className="bg-white text-black px-6 py-3 rounded-full hover:bg-gray-200 transition-colors flex items-center gap-2 whitespace-nowrap"
              >
                Subscribe
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-lg font-semibold mb-4">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('quote')}
                  className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Get Quote
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('testimonials')}
                  className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Testimonials
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-teal-500 mt-1"></i>
                <div>
                  <a href="tel:8165551234" className="text-gray-400 hover:text-white transition-colors">
                    (816) 555-1234
                  </a>
                  <p className="text-gray-500 text-xs">24/7 Emergency Line</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-teal-500 mt-1"></i>
                <a
                  href="mailto:info@kc24cooling.com"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  info@kc24cooling.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-teal-500 mt-1"></i>
                <div className="text-gray-400">
                  123 Main Street
                  <br />
                  Kansas City, MO 64105
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line text-teal-500 mt-1"></i>
                <div className="text-gray-400">
                  Mon-Fri: 7AM - 7PM
                  <br />
                  Sat-Sun: 8AM - 5PM
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-6">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>

            <div className="text-gray-400 text-sm">
              © 2025 KC24Coolingandheating. All rights reserved.
            </div>

            <div className="flex items-center gap-6">
              <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm">
                Terms of Service
              </a>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-white transition-colors text-sm"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
